import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserMailCheckRequestBody, UserMailCheckResponse } from "./types";

export class UserMailCheckAPI extends BaseAPI<
  UserMailCheckRequestBody,
  UserMailCheckResponse
> {
  protected route = ApiRoutes.auth.mail_check;
  protected method = RequestMethod.POST;
}
